/* eslint-disable camelcase */
import { DeviceType, DeviceTypes } from 'AppShell/appshell_types/appshellMetaTypes';
import buildUrl from 'build-url';
import { changeSmartAppBannerLink, FeatureToggles } from 'AppShell/appshell_types';

export const WWNowURL = 'https://zwyf.adj.st';
export const WWNowTrackers: Partial<Record<DeviceType, string>> = { IOS: '71go4xr', ANDROID: 'b47j3xa' };

export const WWURL = 'https://82ef.adj.st';
export const WWTrackers: Partial<Record<DeviceType, string>> = { IOS: '10yfhswo', ANDROID: '10hp9xyv' };

const getWWNowAppUrlParams = (device: DeviceType, currentCountry: string, fallBackFor: DeviceType) => {
    const tracker = WWNowTrackers[device] || '';
    const deepLinkURL = window.location.href;
    const fallbackURL =
        fallBackFor === DeviceTypes.ANDROID
            ? `https://play.google.com/store/apps/details?id=com.westwingnow.android&hl=${currentCountry ?? 'de'}`
            : `https://apps.apple.com/${currentCountry ?? 'de'}/app/westwingnow-ihr-interior-shop/id1140464048`;

    return { tracker, deepLinkURL, fallbackURL, url: WWNowURL };
};
const getOWWAppUrlParams = (device: DeviceType, currentCountry: string, fallBackFor: DeviceType) => {
    const tracker = WWTrackers[device] || '';
    const deepLinkURL = window.location.href;
    const fallbackURL =
        fallBackFor === DeviceTypes.ANDROID
            ? `https://play.google.com/store/apps/details?id=de.westwing.android&hl=${currentCountry ?? 'de'}`
            : `https://apps.apple.com/${currentCountry ?? 'de'}/app/westwing-möbel-deko/id637660112`;

    return { tracker, deepLinkURL, fallbackURL, url: WWURL };
};

export const getFooterAppURL = (
    device: DeviceType,
    fallBackFor: DeviceType,
    currentCountry: string,
    p100ChangeSmartAppBannerLink?: FeatureToggles['p100ChangeSmartAppBannerLink']
    // eslint-disable-next-line max-params
): string => {
    const isOneWWLink =
        p100ChangeSmartAppBannerLink?.includes(fallBackFor.toLowerCase()) ||
        p100ChangeSmartAppBannerLink === changeSmartAppBannerLink.all;
    const { tracker, deepLinkURL, fallbackURL, url } = isOneWWLink
        ? getOWWAppUrlParams(device, currentCountry, fallBackFor)
        : getWWNowAppUrlParams(device, currentCountry, fallBackFor);

    if ([DeviceTypes.ANDROID, DeviceTypes.IOS].includes(device as DeviceTypes)) {
        return buildUrl(url, {
            queryParams: {
                adjust_t: tracker,
                adjust_deeplink: deepLinkURL,
                adjust_fallback: fallbackURL,
            },
        });
    }
    return fallbackURL;
};
